import { Injectable } from '@angular/core';
import { SocketNameSpace } from "./socket-name-space";
import { UserService } from "@gatho/services/user/user.service";
import { environment } from "@gatho/../environments/environment";
import { LobbyData, SocEvents } from '@shared/classes/SocEvents';
import {
  Area,
  Site,
  AreaRoomData,
  UserRole,
  AreaConnectedUserCount,
  DynamicContent
} from '@shared/models/';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LobbySignalService {
  private namespace = 'lobby-data';
  private ns!: SocketNameSpace;

  constructor(
    private userService: UserService
  ) {}

  private _initUserSubscription?: Subscription;
  private _init$ = new Subject<void>();

  initLobbySignalService(onInit?: () => void): boolean {
    if (this.ns) return true;
    if (onInit) this._init$.subscribe(() => onInit());
    // Check that there is a current user
    const { uuid } = this.userService.getUser() ?? {};
    if (uuid) {
      // Connect to the socket
      this.ns = new SocketNameSpace(environment.socket_server, this.namespace, uuid);
      this.onConnect().subscribe(() => {
        this.bootUserSubscriber();
      });
      this._init$.next();
      this._init$.complete();
    }
    else if (!this._initUserSubscription) {
      this._initUserSubscription = this.userService.getUserObserv().subscribe(user => {
        if (user && this.initLobbySignalService()) {
          this._initUserSubscription?.unsubscribe();
          this._initUserSubscription = undefined;
        }
      });
    }
    return !!this.ns;
  }

  disconnectFromSocket() {
    this.ns.disconnect();
  }

  private onConnect() {
    return this.ns.fromEvent<void>('connect');
  }

  public onUserNotFound() {
    return this.ns.fromEvent<void>(SocEvents.userNotFound);
  }

  public onAllLobbyData() {
    return this.ns.fromEvent<LobbyData>(SocEvents.allLobbyData);
  }
  public onDrupalEvent() {
    return this.ns.fromEvent(SocEvents.drupalAction);
  }
  public onDataSiteTypes() {
    return this.ns.fromEvent<Site[]>(SocEvents.dataSiteTypes);
  }
  public onDataSites() {
    return this.ns.fromEvent<Site[]>(SocEvents.dataSites);
  }
  public onDataArea() {
    return this.ns.fromEvent<Area[]>(SocEvents.dataArea);
  }
  public onDataDynamicContent() {
    return this.ns.fromEvent<DynamicContent[]>(SocEvents.dataDynamicContent);
  }
  private onBootUser() {
    return this.ns.fromEvent<void>(SocEvents.bootUser);
  }
  public onAreaConnectedUserCount(){
    return this.ns.fromEvent<AreaConnectedUserCount[]>(SocEvents.dataAreaConnectedUserCount);
  }

  public onAreaRoomsData() {
    return this.ns.fromEvent<AreaRoomData[]>(SocEvents.areaRooms);
  }

  public onUserRolesData() {
    return this.ns.fromEvent<UserRole[]>(SocEvents.userRoles);
  }

  private bootUserSubscriber(){
    this.onBootUser().subscribe(async () => {
      this.disconnectFromSocket();
      alert("You have been blacklisted from gatho due to user reports, contact support@gatho.app if you feel this shouldn't have happened");
      this.userService.clearUserData();
      window.location.reload();
    });
  }

  /**
   * Handles the drupal triggered action.
   * @param data
   */
  public handleDrupalAction(data: any) {
    if (data.event && data.data) {
      switch (data.event) {
        case 'remove_performer':
          const performerUserUUID = data.data.uuid;
            console.log('please remove_performer ' + performerUserUUID);
          break;
        case 'kick_user':
           const userUUID = data.data.uuid;
             console.log('please kick user ' + userUUID);
          break;
        case 'performer_stream_delete':
           const streamKeyID = data.data.streamKey;
           console.log('please handle ' + data.event + ' streamKey ' + streamKeyID);
          break;
        case 'performer_create_stream':
        case 'performer_update_stream':
            // eslint-disable-next-line no-case-declarations
            const streamKey = data.data.data.streamKey; // <-this is the redis key
            console.log('please handle ' + data.event + ' streamKey ' + streamKey);
          break;

        default:
            console.log('Lobby data socket not handled', data);
          break;
      }
    }
  }
}
